/*
	[ Highly-volatile ] fields:
	- These fields values change very often. Endpoint doesn't need caching.
 */

import { Model } from "@models";
import { IndexAllocation } from "@models/tradable/index-allocation";

export class AssetPrice extends Model {
	protected circulating_supply: string = "";
	protected market_cap: string = "";
	protected price: string = "";
	protected price_amount_changes: PriceChanges = new PriceChanges();
	protected price_percentage_changes: PriceChanges = new PriceChanges();
	protected index_assets: IndexAllocation[] = [new IndexAllocation()];

	public getCirculatingSupply(): number {
		return +this.circulating_supply;
	}

	public setCirculatingSupply(s: string): void {
		this.circulating_supply = s;
	}

	public getMarketCap(): number {
		return +this.market_cap;
	}

	public getPrice(): number {
		return +this.price;
	}

	public setPrice(price: number): void {
		this.price = price + "";
	}

	public getChange24h(): number {
		return +this.price_percentage_changes.getDay();
	}

	public getChange1w(): number {
		return +this.price_percentage_changes.getWeek();
	}

	public getChange1m(): number {
		return +this.price_percentage_changes.getMonth();
	}

	public getChange6m(): number {
		return +this.price_percentage_changes.getSixMonths();
	}

	public getChange1y(): number {
		return +this.price_percentage_changes.getYear();
	}

	public getChange5y(): number {
		return +this.price_percentage_changes.getFiveYears();
	}

	public getChange24hAmount(): number {
		return +this.price_amount_changes.getDay();
	}

	public getChange1wAmount(): number {
		return +this.price_amount_changes.getWeek();
	}

	public getChange1mAmount(): number {
		return +this.price_amount_changes.getMonth();
	}

	public getChange6mAmount(): number {
		return +this.price_amount_changes.getSixMonths();
	}

	public getChange1yAmount(): number {
		return +this.price_amount_changes.getYear();
	}

	public getChange5yAmount(): number {
		return +this.price_amount_changes.getFiveYears();
	}

	public setChange24h(s: string): void {
		this.price_percentage_changes.setDay(s);
	}

	public setChange1w(s: string): void {
		this.price_percentage_changes.setWeek(s);
	}

	public setChange1m(s: string): void {
		this.price_percentage_changes.setMonth(s);
	}

	public setChange6m(s: string): void {
		this.price_percentage_changes.setSixMonths(s);
	}

	public setChange1y(s: string): void {
		this.price_percentage_changes.setYear(s);
	}

	public setChange5y(s: string): void {
		this.price_percentage_changes.setFiveYears(s);
	}

	public setChange24hAmount(s: string): void {
		this.price_amount_changes.setDay(s);
	}

	public setChange1wAmount(s: string): void {
		this.price_amount_changes.setWeek(s);
	}

	public setChange1mAmount(s: string): void {
		this.price_amount_changes.setMonth(s);
	}

	public setChange6mAmount(s: string): void {
		this.price_amount_changes.setSixMonths(s);
	}

	public setChange1yAmount(s: string): void {
		this.price_amount_changes.setYear(s);
	}

	public setChange5yAmount(s: string): void {
		this.price_amount_changes.setFiveYears(s);
	}

	public getIndexAllocations(): IndexAllocation[] {
		return this.index_assets;
	}
}

export class PriceChanges {
	private day: string = "";
	private month: string = "";
	private week: string = "";
	private six_months: string = "";
	private year: string = "";
	private five_years: string = "";

	public getDay(): string {
		return this.day;
	}

	public getMonth(): string {
		return this.month;
	}

	public getWeek(): string {
		return this.week;
	}

	public getSixMonths(): string {
		return this.six_months;
	}

	public getYear(): string {
		return this.year;
	}

	public getFiveYears(): string {
		return this.five_years;
	}

	public setDay(s: string): void {
		this.day = s;
	}

	public setWeek(s: string): void {
		this.week = s;
	}

	public setMonth(s: string): void {
		this.month = s;
	}

	public setSixMonths(s: string): void {
		this.six_months = s;
	}

	public setYear(s: string): void {
		this.year = s;
	}

	public setFiveYears(s: string): void {
		this.five_years = s;
	}
}
